import { Order } from '../types';

export interface DriverDailyStats {
  deliveries: number;
  orders: Order[];
}

export const getLocalDayRange = (now: Date = new Date()): { startMs: number; endMs: number } => {
  const start = new Date(now);
  start.setHours(0, 0, 0, 0);
  const end = new Date(start);
  end.setDate(end.getDate() + 1);
  return { startMs: start.getTime(), endMs: end.getTime() };
};

export const getOrderCompletionDriverId = (order: Order): string | undefined => order.completedDriverId || order.driverId;

export const isCompletedDeliveryOrder = (order: Order): boolean =>
  order.status === 'delivered' || (order.status === 'archived' && typeof order.deliveredAt === 'number');

export const getOrderCompletionTimestamp = (order: Order): number | undefined => {
  if (order.status === 'archived') return order.deliveredAt;
  return order.deliveredAt || order.statusUpdatedAt;
};

export const getDriverDailyStats = (
  orders: Order[],
  driverId: string,
  now: Date = new Date()
): DriverDailyStats => {
  const { startMs, endMs } = getLocalDayRange(now);
  const driverOrders = orders.filter((order) => {
    if (!isCompletedDeliveryOrder(order)) return false;
    if (getOrderCompletionDriverId(order) !== driverId) return false;
    const completedAt = getOrderCompletionTimestamp(order);
    return typeof completedAt === 'number' && completedAt >= startMs && completedAt < endMs;
  });

  return {
    deliveries: driverOrders.length,
    orders: driverOrders,
  };
};

export const getDriverDeliveredOrders = (orders: Order[], driverId: string): Order[] =>
  orders.filter((order) =>
    isCompletedDeliveryOrder(order) &&
    getOrderCompletionDriverId(order) === driverId
  );
